import styled from 'styled-components';
import {IconButton} from "@mui/material";

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    min-height: 100px;
    margin: 30px;
`
export const StyledIconButton = styled(IconButton)<{ $disabled: boolean }>`
    padding: 5px;
    
    svg {
        color: ${({$disabled, theme}) => $disabled ? theme.palette.secondary.light : theme.palette.primary.main };
        fill: ${({$disabled, theme}) => $disabled ? theme.palette.secondary.light : theme.palette.primary.main };
    }
`;